import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormMutation } from "../../../../../core/service/types/FormMutation";
import type { FormQuery } from "../../../../../core/service/types/FormQuery";
import type { Dto } from "../../../../../core/types/be/Dto";
import type { DialogProfileEntity } from "../../types/DialogProfileEntity";
import { DialogProfileDtoToEntity } from "../mappers/DialogProfileDtoToEntity";
import { DialogProfileEntityToDto } from "../mappers/DialogProfileEntityToDto";

const DialogProfileApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        DialogProfileLoad: builder.query<DialogProfileEntity, FormQuery>({
            providesTags: [ResourceName.DIALOG_PROFILES],
            query: (queryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.DIALOG_PROFILES}/${queryParams.entityId}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return DialogProfileDtoToEntity(response);
            },
        }),
        DialogProfileSave: builder.mutation<DialogProfileEntity, FormMutation<DialogProfileEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.DIALOG_PROFILES}`;
                const method = "POST";

                const body = DialogProfileEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.DIALOG_PROFILES],
        }),
        DialogProfileUpdate: builder.mutation<DialogProfileEntity, FormMutation<DialogProfileEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.DIALOG_PROFILES}/${mutation.data.id}`;
                const method = "PUT";

                const body = DialogProfileEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.DIALOG_PROFILES],
        }),
    }),
});

export const { useDialogProfileLoadQuery, useDialogProfileSaveMutation, useDialogProfileUpdateMutation } = DialogProfileApi;
